import React from "react";
import { Star, BadgeCheck } from "lucide-react";
import { useI18n } from "../lib/i18n";
import { MIN_REVIEWS_FOR_RATING } from "../lib/format";

// Shows "New" until a provider has enough reviews; otherwise ★ rating (count)
export function Rating({ rating, count, size = 14, className = "", light = false }) {
  const { t } = useI18n();
  if (!count || count < MIN_REVIEWS_FOR_RATING) {
    return (
      <span data-testid="rating-new" className={`inline-flex items-center text-[11px] uppercase tracking-wider px-2 py-0.5 rounded-full ${light ? "bg-white/20 text-white" : "bg-stone-900 text-white"} ${className}`}>
        {t("rating_new")}
      </span>
    );
  }
  return (
    <span data-testid="rating-value" className={`inline-flex items-center gap-1 ${className}`}>
      <Star size={size} className={light ? "fill-amber-300 text-amber-300" : "fill-stone-800 text-stone-800"} />
      <span className="font-medium">{rating}</span>
      <span className={light ? "text-white/70" : "text-stone-400"}>({count})</span>
    </span>
  );
}

export function VerifiedBadge({ className = "", compact = false }) {
  const { t } = useI18n();
  return (
    <span data-testid="verified-badge" title={t("verified_tip")} className={`inline-flex items-center gap-1 text-[11px] font-medium text-emerald-700 bg-emerald-50 border border-emerald-100 rounded-full ${compact ? "px-1.5 py-0.5" : "px-2 py-0.5"} ${className}`}>
      <BadgeCheck size={12} />{!compact && t("verified")}
    </span>
  );
}
